import { useState } from "react";
import type { Provider } from "../types";
import { providerIconUrl, providerInitials } from "../lib/icons";

export function ProviderIcon({
  provider,
  size = 20,
  className = "",
}: {
  provider: Pick<Provider, "id" | "iconSlug" | "name"> | undefined;
  size?: number;
  className?: string;
}) {
  const [failed, setFailed] = useState(false);
  if (!provider) {
    return (
      <span className={`provider-icon fallback ${className}`} style={{ width: size, height: size }}>
        ?
      </span>
    );
  }
  if (failed || !provider.iconSlug) {
    return (
      <span
        className={`provider-icon fallback ${className}`}
        style={{ width: size, height: size, fontSize: Math.max(9, size * 0.42) }}
        title={provider.name}
        aria-hidden
      >
        {providerInitials(provider.name)}
      </span>
    );
  }
  return (
    <img
      className={`provider-icon ${className}`}
      src={providerIconUrl(provider)}
      alt=""
      width={size}
      height={size}
      loading="lazy"
      onError={() => setFailed(true)}
    />
  );
}
